/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ClaimTab/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function ClaimTab({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/Content/Tabs/Content/ClaimTab"
  
}) {
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Claim"
 isSelected={true}
 size="normal"
 color={dtColorsNeutral900}
/>
{children}
</React.Fragment>)
}